module.exports = __webpack_public_path__ + "static/media/Titillium-Regular.90a961b1.otf";